import { render, staticRenderFns } from "./levelFourPagesCPJS.vue?vue&type=template&id=bb71e6ce&scoped=true&"
import script from "./levelFourPagesCPJS.vue?vue&type=script&lang=js&"
export * from "./levelFourPagesCPJS.vue?vue&type=script&lang=js&"
import style0 from "./levelFourPagesCPJS.vue?vue&type=style&index=0&id=bb71e6ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bb71e6ce",
  null
  
)

export default component.exports